import { useParams } from "react-router-dom";

import { Layout } from "Layout";

import { ListPage } from "components/ListPage/ListPage";

import { i18n } from "services/i18nService";

import { useEditModal } from "hooks/useEditModal";
import { usePrivileges } from "hooks/usePrivileges";

import { Forbidden } from "Forbidden";
import { OBJECT_TYPES } from "appConstants";

const objectType = OBJECT_TYPES.CLASS.fullString;

export function ClassList() {
  const { id } = useParams();
  const { isAdmin } = usePrivileges();

  useEditModal(objectType, id);

  return (
    <Layout pageTitle={i18n(`objectType.${objectType}.SentencePlural`)}>
      {isAdmin ? <ListPage objectType={objectType} /> : <Forbidden />}
    </Layout>
  );
}
